import ProjectTypeContainer from "./ProjectTypeContainer";

export default ProjectTypeContainer;
